import Breadcrumb from '@Services/Breadcrumb';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import { generateResultsPath } from '@AppRoutes/utils';
import history from '@AppRoutes/history';
import { getRelativeContexts } from './RelativeContextService';
import { saveRelativeContextType, clearRelativeContextType } from './RelativeContextConstants';
import { orderedRelativeContextByHitSetKey as orderedRelativeContextByHitSetKeySelector } from './RelativeContextSelectors';

export function saveRelativeContext(relativeContexts, hitSetKey) {
  return {
    type: saveRelativeContextType,
    payload: {
      hitSetKey,
      relativeContexts,
    },
  };
}

export function updateHitSetKey(dispatch, hitSetKey) {
  const location = history.location.state;
  // Update only if it is results page
  if (!history.location.pathname.includes('results') && !history.location.pathname.includes('list')) return null;

  const params = { ...location, hitSetKey, type: 'list' };

  params.hitSetKey = hitSetKey;
  const pathName = generateResultsPath(params);

  return history.replace({
    pathname: pathName,
    state: params,
  });
}

export function fetchRelativeContexts(params) {
  return async (dispatch, getState) => {
    const state = getState();
    const databaseId = databaseIdSelector(state) || params.databaseId;
    const activeBreadCrumb = Breadcrumb.getActiveBreadcrumbForDb(databaseId);

    if (!activeBreadCrumb) return undefined;

    const { resultSize } = activeBreadCrumb;
    const { context, hitSetKey } = params;
    const existentRelativeContext = orderedRelativeContextByHitSetKeySelector(state, { hitSetKey });

    if (existentRelativeContext) {
      return existentRelativeContext;
    }

    const { hitSetKey: newHitSetKey, normalizedRelativeContexts } = await getRelativeContexts(params, history);
    const rootBreadcrumb = Breadcrumb.retrieveRootActiveBreadcrumb(activeBreadCrumb);
    const currentAssistantEligible = activeBreadCrumb.assistantEligible ?? rootBreadcrumb?.assistantEligible;

    const resultRelativeContexts = [
      {
        ...params,
        hitSetKey: newHitSetKey,
        id: context,
        resultSize,
        ...(currentAssistantEligible !== undefined && { assistantEligible: currentAssistantEligible }),
      },
      ...normalizedRelativeContexts,
    ];

    dispatch(saveRelativeContext(resultRelativeContexts, newHitSetKey));

    if (hitSetKey !== newHitSetKey) {
      await updateHitSetKey(dispatch, newHitSetKey);
    }

    return orderedRelativeContextByHitSetKeySelector(getState(), { hitSetKey: newHitSetKey });
  };
}

export function clearRelativeContext() {
  return {
    type: clearRelativeContextType,
  };
}
